import type {Language} from '@navbar-unlogged-types';
import {navigateTo, useLocalePrefix, useMaltEnvironnement, useRuntimeConfig} from '#imports';

export function useLocalizationSelection() {
    const runtimeConfig = useRuntimeConfig();
    const {withLocalePrefix, withoutLocalePrefix} = useLocalePrefix();

    async function changeLanguageAndRedirect(selectedLanguage: Language) {
        if (selectedLanguage.host) {
            await _changeLanguageAndRedirectForUnloggedUser(selectedLanguage.host, selectedLanguage.locale);
        }
    }

    function _changeLanguageAndRedirectForUnloggedUser(newHost: string, locale?: string) {
        if (newHost) {
            const url = new URL(window.location.href);

            const {enableLocalePrefixStrategy, supportedLocalePrefixes} = runtimeConfig.public['@malt/nuxt-i18n-module'];
            const maybeLocalePrefix = locale?.replace('_', '-').toLowerCase();
            const hasSupportedLocalePrefix = (supportedLocalePrefixes as {prefix: string}[] | undefined)?.some(
                ({prefix}) => prefix === maybeLocalePrefix,
            );
            const shouldUseLocalePrefixStrategy = locale && enableLocalePrefixStrategy && hasSupportedLocalePrefix;

            if (shouldUseLocalePrefixStrategy) {
                const localePrefix = locale?.replace('_', '-').toLowerCase(); // fr_FR -> fr-fr
                url.host = getMultiLocaleHost();
                url.pathname = withLocalePrefix(url.pathname, localePrefix) as string;
            } else {
                // Remove any existing locale prefix when redirecting to a classic domain
                url.pathname = withoutLocalePrefix(url.pathname) as string;
                url.host = newHost;
            }

            navigateTo(url.toString(), {external: true});
        }
    }

    function getMultiLocaleHost() {
        const environment = useMaltEnvironnement();

        switch (environment) {
            case 'DEV':
                return 'dev.malt.com';
            case 'DEV_INTEGRATION':
                return 'dev.integration.malt.com';
            case 'INTEGRATION':
                return 'www.integration.malt.com';
            case 'PRODUCTION':
            case 'UNKNOWN':
            default:
                return 'www.malt.com';
        }
    }

    return {
        // functions A-Z
        changeLanguageAndRedirect,
        // refs A-Z
    };
}
